import { createMarketTrends } from 'app/shared/models/MarketTrends';
import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => createMarketTrends();

export const marketTrends = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.SET_MARKET_STATS) {
    return assign({}, state, payload);
  }
  return state;
};

// used for FAQ params
export const unfilteredMarketTrends = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.SET_UNFILTERED_MARKET_STATS) {
    return assign({}, state, payload);
  }
  return state;
};
